import { render, staticRenderFns } from "./TemplateCreateDialog.vue?vue&type=template&id=0765ac95"
import script from "./TemplateCreateDialog.vue?vue&type=script&lang=ts"
export * from "./TemplateCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports